import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Admin from "../pages/admin/page";
import ProductsPage from "../pages/products/page";
import ProductDetail from "../pages/products/detail";
import NewsPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/admin/",
    element: <Admin />,
  },
  {
    path: "/admin/index.html",
    element: <Admin />,
  },
  {
    path: "/admin/default.html",
    element: <Admin />,
  },
  {
    path: "/admin/default.htm",
    element: <Admin />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:id",
    element: <ProductDetail />,
  },
  {
    path: "/news",
    element: <NewsPage />,
  },
  {
    path: "/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
